// Premium pill button with an elegant animated arrow.
// variant: "solid" (ink) | "outline" (hairline) | "outline-light"
// Use `href` for external links, or `to` (selector) for in-page smooth scroll (clean URL).
import { scrollToId } from "../lib/scroll";

export default function PillButton({
    children,
    href,
    to,
    variant = "solid",
    external = false,
    className = "",
    testId,
    full = false,
}) {
    const base =
        "pill group relative font-sans text-[0.95rem] tracking-wide select-none";
    const solid = {
        backgroundColor: "var(--ink)",
        color: "var(--bg)",
    };
    const outline = {
        border: "1px solid var(--ink)",
        color: "var(--ink)",
        backgroundColor: "transparent",
    };
    const outlineLight = {
        border: "1px solid rgba(252,251,248,0.7)",
        color: "var(--bg)",
        backgroundColor: "transparent",
    };

    const styleFor =
        variant === "solid"
            ? solid
            : variant === "outline-light"
              ? outlineLight
              : outline;

    const handleEnter = (e) => {
        if (variant === "solid") {
            e.currentTarget.style.backgroundColor = "var(--accent)";
        } else if (variant === "outline-light") {
            e.currentTarget.style.backgroundColor = "var(--bg)";
            e.currentTarget.style.color = "var(--ink)";
            e.currentTarget.style.borderColor = "var(--bg)";
        } else {
            e.currentTarget.style.backgroundColor = "var(--ink)";
            e.currentTarget.style.color = "var(--bg)";
        }
    };
    const handleLeave = (e) => {
        if (variant === "solid") {
            e.currentTarget.style.backgroundColor = "var(--ink)";
        } else if (variant === "outline-light") {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.color = "var(--bg)";
            e.currentTarget.style.borderColor = "rgba(252,251,248,0.7)";
        } else {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.color = "var(--ink)";
        }
    };

    const commonProps = {
        "data-testid": testId,
        className: `${base} ${className}`,
        style: {
            ...styleFor,
            height: "66px",
            width: full ? "100%" : "352px",
            maxWidth: "100%",
            paddingLeft: "2rem",
            paddingRight: "2rem",
        },
        onMouseEnter: handleEnter,
        onMouseLeave: handleLeave,
    };

    const inner = (
        <span className="inline-flex items-center gap-3">
            <span>{children}</span>
            <span
                aria-hidden="true"
                className="inline-block transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-x-1.5"
            >
                →
            </span>
        </span>
    );

    if (to) {
        return (
            <button
                type="button"
                onClick={() => scrollToId(to)}
                {...commonProps}
            >
                {inner}
            </button>
        );
    }

    return (
        <a
            href={href}
            {...(external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
            {...commonProps}
        >
            {inner}
        </a>
    );
}
